import { render } from "./InsertDialog.vue?vue&type=template&id=6138b6ed"
import script from "./InsertDialog.vue?vue&type=script&lang=js"
export * from "./InsertDialog.vue?vue&type=script&lang=js"

import "./InsertDialog.vue?vue&type=style&index=0&id=6138b6ed&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__